import React from 'react';
import * as ReactDOM from 'react-dom';

import { QueryClientProvider } from '@tanstack/react-query';

import { queryClient } from '~teacher/queryClient';
import HeaderController from 'HeaderController';
import RenewalModel from 'RenewalModel';
import RenewalView from 'RenewalView';

let router = null;

class RenewalController {
  initialize(teacherRouter) {
    router = teacherRouter;

    if (RenewalModel.show) {
      controller.render();
    }
  }

  render() {
    ReactDOM.render(
      <QueryClientProvider client={queryClient}>
        <RenewalView controller={controller} model={RenewalModel} />
      </QueryClientProvider>,
      document.getElementById('renewal-notify-container')
    );
  }

  renewNowClicked() {
    router.routeToProfileBilling();
  }

  closeClicked() {
    RenewalModel.show = false;

    let notify = document.getElementById('renewal-notify');

    if (notify) {
      notify.style.top = '-200px';
      setTimeout(() => {
        RenewalModel.closeBanner();
        clearTimeout();
      }, 200);
    }

    HeaderController.hideMobileMenus();
  }

  // This method is used externally to dismiss the notice after successful renewal.
  closeAfterRenewal() {
    ReactDOM.unmountComponentAtNode(
      document.getElementById('renewal-notify-container')
    );
    RenewalModel.clear();
    HeaderController.rerender();
  }
}

let controller = new RenewalController();
module.exports = controller;
